import type { LucideIcon } from 'lucide-react';
import { Bell, CircleCheck, List } from 'lucide-react';
import { Card, Description, Skeleton } from '@heroui/react';
import type { DashboardStats } from '../../../api/dashboard';

interface StatCardConfig {
  key: keyof DashboardStats;
  label: string;
  Icon: LucideIcon;
  iconClassName: string;
  iconWrapClassName: string;
}

const STAT_CARDS: StatCardConfig[] = [
  {
    key: 'activeUsages',
    label: 'Usos ativos',
    Icon: CircleCheck,
    iconClassName: 'text-success',
    iconWrapClassName: 'bg-success/10',
  },
  {
    key: 'pendingRequests',
    label: 'Solicitações pendentes',
    Icon: Bell,
    iconClassName: 'text-warning',
    iconWrapClassName: 'bg-warning/10',
  },
  {
    key: 'totalUsages',
    label: 'Total de usos',
    Icon: List,
    iconClassName: 'text-muted',
    iconWrapClassName: 'bg-default',
  },
];

interface StatsCardsProps {
  stats?: DashboardStats;
  isLoading?: boolean;
}

export function StatsCards({ stats, isLoading }: StatsCardsProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {STAT_CARDS.map((card) => (
          <Skeleton key={card.key} className="h-24 w-full rounded-xl" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {STAT_CARDS.map(({ key, label, Icon, iconClassName, iconWrapClassName }) => (
        <Card key={key}>
          <Card.Content className="flex flex-row items-center gap-3 p-4">
            <div
              className={`flex size-12 shrink-0 items-center justify-center rounded-full ${iconWrapClassName}`}
            >
              <Icon size={22} className={iconClassName} />
            </div>
            <div className="min-w-0">
              <Description className="text-sm">{label}</Description>
              <p className="text-3xl font-bold text-foreground">{stats?.[key] ?? 0}</p>
            </div>
          </Card.Content>
        </Card>
      ))}
    </div>
  );
}
